import { queryKeys } from '../../lib/queryKeys';
import type { RequestError } from '../../shared';
import { observableToPromise } from '../../shared/observableToPromise';
import { getAccountSubscription, type Subscription } from '../api';
import type { Account } from '../model';

import { useAccountQuery } from './useAccountQuery';

export function useAccountSubscription(account: Account | null | undefined) {
  return useAccountQuery<Subscription | null, RequestError>(
    account ? queryKeys.accounts.subscription(account._id) : ['accounts', 'subscription', null],
    ({ signal }) => (account ? observableToPromise(getAccountSubscription(account), signal) : Promise.resolve(null)),
    account,
  );
}
